export default __webpack_public_path__ + "static/media/thirteen.4e5e4c5d.jpeg";